helpers.calculatePasswordStrength = function(password) {
  var charTypes, lower, number, special, strength, upper;
  upper = /[A-Z]/;
  lower = /[a-z]/;
  number = /[0-9]/;
  special = /[\~\!\@\#\$\%\^\&\*\_\-\+\=\|\\\(\)\{\}\[\]\:<>\,\.\?\/]/;
  charTypes = 0;
  strength = 0;
  if (lower.test(password)) {
    charTypes++;
  }
  if (upper.test(password)) {
    charTypes++;
  }
  if (number.test(password)) {
    charTypes++;
  }
  if (special.test(password)) {
    charTypes++;
  }
  if (password.length < 8) {
    strength = 0;
  } else if (charTypes < 3) {
    strength = 1;
  } else if (password.length === 8 && charTypes === 3) {
    strength = 2;
  } else if (password.length >= 9 && charTypes === 3) {
    strength = 3;
  } else if (password.length >= 9 && charTypes === 4) {
    strength = 4;
  } else {
    strength = 0;
  }
  return strength;
};
